export default "__VITE_ASSET__DHYub6rD__"